exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".impostazione-cookie-float-btn {\n  position: fixed;\n  bottom: 0px;\n  left: 20px;\n  z-index: 10;\n  font-weight: bold;\n}\n\n@media only screen and (max-width: 768px) {\n  .impostazione-cookie-float-btn {\n    border: 2px solid #00539c;\n    left: 10px;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/impostazione-cookie/impostazione-cookie.component.css
// module id = ../../../../../src/app/components/utilita/impostazione-cookie/impostazione-cookie.component.css
// module chunks = main